export const CommonUsesData = [
  {
    title: "Document ",
    subTitle: "Translation Services",
    detail:
      "If you're looking to translate large amounts of documents, you'll need Tomedes. Our large network of translators can handle any type of document, such as business, legal, and medical documents. Native translators experts in the particular industry are the ones translating your work, so no need to worry. There's also the option of machine translation post editing for large documentations. Start today.",
    link: "/document-translation-services",
  },
  {
    title: "Certified",
    subTitle: " Translation Services",
    detail:
      "As a Seattle translation company, Tomedes is known for certified translation services. We're certified by the American Translator's Association as an authority in the field. Translators will handle your translations, then Tomedes will certify and authenticate the translation for use in your applications, be it for university or immigration purposes.",
    link: "/certified-translation.php",
  },
];
